import React, { Component } from 'react';
import ErrorComponent from '../../../../common/components/ErrorCard';

// import * as Sentry from '@sentry/browser';
export default class DynamicImport extends Component {
  state = {
    component: null,
    hasError: false
  };

  componentDidMount() {
    this.load();
  }

  retryCount = 0;

  load() {
    this.props
      .load()
      .then(component => {
        const moduleName = this.props.moduleName || 'default';
        this.setState(() => ({
          hasError: false,
          component: component[moduleName] ? component[moduleName] : ErrorComponent
        }));
      })
      .catch(() => {
        this.retryCount++;
        if (this.retryCount < 5) {
          this.load();
        } else {
          // Sentry.captureEvent({
          //   message: `Failed to load module after 5 retries : ${error.message}`,
          //   stacktrace: [
          //     error.stacktrace
          //   ],
          // });
          this.setState({
            hasError: true,
            component: ErrorComponent
          });
        }
      });
  }

  onRefreshClick = () => {
    // Sentry.captureEvent({
    //   message: 'Browser refreshed when failed to load module'
    // });
    setTimeout(() => {
      window.location.reload();
    }, 0);
  };

  render() {
    if (!this.state.component) {
      if (this.props.loadingComp) {
        return this.props.loadingComp;
      }
      return null;
    }
    const LoadedComponent = this.state.component;
    const props = { ...this.props.componentProps };
    if (this.state.hasError) {
      props.onRefreshClick = this.onRefreshClick;
    }

    return <LoadedComponent {...props} handleRefresh={this.onRefreshClick} />;
  }
}
